import { FC, ReactNode } from 'react'

import { GlobalStyle } from 'styles/global'
import { Footer } from './footer'
import { Header } from './header'

export type LayoutProps = {
  headerOnTop?: boolean
  children: ReactNode
  hasTransparentHeader?: boolean
  invertedHeader?: boolean
}

export const Layout: FC<LayoutProps> = ({
  children,
  headerOnTop,
  invertedHeader = false,
  hasTransparentHeader = true,
}) => (
  <>
    <Header
      onTop={headerOnTop}
      isTransparent={hasTransparentHeader}
      inverted={invertedHeader}
    />
    <GlobalStyle />
    {children}
    <Footer />
  </>
)
